import React from "react";

const useProgressiveImg = (
  lowQualitySrc,
  highQualitySrc,
  fetchPriority,
  setImgfetchStatus
) => {
  const [src, setSrc] = React.useState(lowQualitySrc);
  React.useEffect(() => {
    setSrc(lowQualitySrc);
    const img = new Image();
    if (fetchPriority) {
      img.fetchPriority = fetchPriority;
    }
    img.src = highQualitySrc;
    img.onload = () => {
      setSrc(highQualitySrc);
      setImgfetchStatus && setImgfetchStatus(true);
    };
  }, [lowQualitySrc, highQualitySrc, fetchPriority]);
  return [src, { blur: src === lowQualitySrc }];
};

export default useProgressiveImg;
